(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dbsm-editor-app", [], factory);
	else if(typeof exports === 'object')
		exports["dbsm-editor-app"] = factory();
	else
		root["dbsm-editor-app"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 